import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButton from '@mui/material/ToggleButton';
import IconButton from '@mui/material/IconButton';
import PrintIcon from '@mui/icons-material/Print';
import { get, size } from 'global/lib/lodash';
import { BtnGroup, Container, Inner, RowItem } from './styles';
import { setView } from 'redux/actions/view';
import { Text } from '../text';
import Switch from '../switch';
import { useEdit } from '../../hooks/useEdit';
import { useFilter } from '../../hooks/useFilter';
import { useShowChanges } from '../../hooks/useShowChanges';
import { userHasPermissions } from 'redux/actions/userLogin';
import { useUser } from '../../hooks/useUser';
import { useScreen } from 'global/styles';

export const SelectLangEditBar = (props) => {
  const showTranslations = get(props, 'showTranslations', false);
  const hasPerm = userHasPermissions(['createLibrary']);
  const canEdit = get(props, 'canEdit', hasPerm);
  const canShowChanges = get(props, 'canShowChanges');
  const onPrintSelect = get(props, 'onPrintSelect');
  const selectionMode = get(props, 'selectionMode', false);
  const uhook = useUser();
  const [showLocation, setShowLocation] = useState(get(props, 'showLocation', true));
  const { isMobile } = useScreen();

  const { editOn, toggleEdit } = useEdit();
  const { showChangesOn, toggleShowChanges } = useShowChanges();
  const { filter, changeFilter } = useFilter('library.editions');

  const lang = useSelector((state) => get(state, 'view.lang'));
  const dispatch = useDispatch();

  const handleChange = (e, val) => {
    if (val) {
      dispatch(setView({ lang: { ...lang, id: val } }));
    }
  };

  const locationOn = !!get(filter, 'useLocation', false);

  const changeLocation = () => {
    changeFilter('useLocation', !locationOn);
  };

  const userIsBuilderTier = get(uhook, 'siteContextRealmTier') === 'builder';

  useEffect(() => {
    const tier = get(uhook, 'siteContextRealmTier');

    if (tier) {
      if (tier === 'builder') {
        changeFilter('useLocation', false);
      } else if (tier === 'division') {
        changeFilter('useLocation', true);
      }
    }
  }, [uhook.siteContextRealmTier]);

  useEffect(() => {
    if (props.edition) {
      const edtier = get(props, 'edition.realm.tier');
      const hasdocs = get(props, 'edition.config.docs');
      if (edtier === 'division' || !hasdocs) {
        setShowLocation(false);
      }
    }
  }, [props.edition]);

  const show = showTranslations || canEdit || showLocation || canShowChanges || !!onPrintSelect;

  if (!show) {
    return null;
  }

  return (
    <Container>
      <Inner>
        {showTranslations && (
          <RowItem>
            {!isMobile && <Text type={'label_medium'}>Available In</Text>}
            <BtnGroup exclusive size="small" value={get(lang, 'id')} onChange={handleChange} sx={isMobile ? { marginLeft: 0 } : undefined}>
              {get(lang, 'avail', []).map((a) => (
                <ToggleButton key={a.id} value={a.id}>
                  {a.title}
                </ToggleButton>
              ))}
            </BtnGroup>
          </RowItem>
        )}

        {canEdit && (
          <RowItem>
            <Text type={'label_medium'}>{isMobile ? 'Edit' : 'Edit Tools'}</Text>
            <Switch checked={editOn} onChange={toggleEdit} />
          </RowItem>
        )}

        {canShowChanges && (
          <RowItem>
            <Text type={'label_medium'}>Show Changes</Text>
            <Switch checked={showChangesOn} onChange={() => toggleShowChanges()} />
          </RowItem>
        )}

        {showLocation && (
          <RowItem>
            <Text type={'label_medium'}>Use Location</Text>
            <Switch disabled={userIsBuilderTier} checked={locationOn} onChange={changeLocation} />
          </RowItem>
        )}

        {onPrintSelect && (
          <RowItem>
            <IconButton onClick={onPrintSelect} color={selectionMode ? 'primary' : 'default'} size="small" aria-label="Select standards to print">
              <PrintIcon />
            </IconButton>
          </RowItem>
        )}
      </Inner>
    </Container>
  );
};
